import { render, staticRenderFns } from "./userDashboardSearch.vue?vue&type=template&id=128f0369&scoped=true"
import script from "./userDashboardSearch.vue?vue&type=script&lang=js"
export * from "./userDashboardSearch.vue?vue&type=script&lang=js"
import style0 from "./userDashboardSearch.vue?vue&type=style&index=0&id=128f0369&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128f0369",
  null
  
)

export default component.exports